import React, { type ReactElement } from 'react';
import clsx from 'clsx';

type Props = {
  className?: string;
  children: React.ReactNode;
};

/**
 * Provides a standardised approach to presenting form submit and cancel buttons.
 */
export default function FormButtonsContainer({ className, children }: Props): ReactElement {
  return (
    <div
      className={clsx(className, 'px-1 pt-3 pb-2 d-grid gap-3 d-md-flex justify-content-md-end')}
    >
      {children}
    </div>
  );
}
